<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'避難所情報：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'避難所情報：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <button mat-raised-button color="primary" (click)="addShelter()" [disabled]="!shelterFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content fxFlex="600px" style="overflow: auto;">
    <form class="form" [formGroup]="shelterFormGroup">
      <div class="dialog-body" fxLayout="column" fxLayoutGap="24px">
        <mat-form-field>
          <mat-label floatLabel="always">ID</mat-label>
          <input matInput *ngIf="!isAdded" placeholder="ID" id="shelterId" formControlName="shelterId" readonly>
          <input matInput *ngIf="!!isAdded" placeholder="ID" id="shelterId" formControlName="shelterId">
          <mat-error *ngIf="shelterIdControl.invalid">{{ getErrorMessageToShelterId() }}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
          <input matInput placeholder="{{'名称' | translate}}" id="shelterName" value="{{ shelter!.shelter_names | multiName:projectLanguages:projectBaseLang }}" readonly>
          <button matSuffix mat-stroked-button color="primary" (click)="openShelterNameDialog()">
            <mat-icon>edit</mat-icon>
          </button>
          <mat-error *ngIf="shelterNameControl.invalid">{{ getErrorMessageToShelterName() }}</mat-error>
        </mat-form-field>

        <google-map *ngIf="center" height="400px" width="100%" step="0.00000001" [center]="center" [zoom]="zoom"
          [options]="options">
          <map-marker #markerElem *ngIf="currentPosition" step="0.00000001" [position]="currentPosition"
            [options]="currentPositionMarkerOption" (mapDragend)="onMerkerDragEnd($event)">
          </map-marker>
        </google-map>
        <input #mapSearchField class="map-search-field" type="text"
          (keydown)="onKeyDownFromSearchPlace($event.keyCode)" />
        <button #mapSearchFieldExecute (click)="searchMap()">{{'移動' | translate}}</button>
        <button #mapSearchFieldClear (click)="clearMapSearchField()">{{'クリア' | translate}}</button>

        <div class="shelter-area" fxLayout="row" fxLayoutGap="20px">
          <mat-form-field fxFlex="50%">
            <mat-label floatLabel="always">{{'緯度' | translate}}</mat-label>
            <input matInput placeholder="{{'緯度' | translate}}" id="shelterLat" formControlName="shelterLat" type="number" step="0.00000001" (change)="onBlurMarkerLat()">
            <mat-error *ngIf="shelterLatControl.invalid">{{ getErrorMessageToShelterLat() }}</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="50%">
            <mat-label floatLabel="always">{{'経度' | translate}}</mat-label>
            <input matInput placeholder="{{'経度' | translate}}" id="shelterLng" formControlName="shelterLng" type="number" step="0.00000001" (change)="onBlurMarkerLng()">
            <mat-error *ngIf="shelterLngControl.invalid">{{ getErrorMessageToShelterLng() }}</mat-error>
          </mat-form-field>
        </div>

        <mat-checkbox formControlName="showMarker" color="primary">{{'MAPページに位置を表示する' |
          translate}}</mat-checkbox>
      </div>
    </form>
  </div>


</div>